<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            nhập kho</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Ngày tạo:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-date-picker  format="DD/MM/YYYY" v-model="search.createDate" type="daterange"
                  range-separator="-" start-placeholder="Từ ngày" end-placeholder="đến ngày" style="width: 100%"
                  :clearable="false" @change="getInventoryReport" />
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="getInventoryReport"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
      </div>
      <div class=card-body>
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%" fit
            stripe highlight-current-row v-loading="isLoading">
            <el-table-column prop="odooName" label="Sản phẩm" header-align="center">
              <template #default="scope">
                <div style="display: flex; gap: 10px">
                  <el-image style="width: 50px; height: 50px" :src="baseUrl + '/product/img/' + scope.row.odooImage1920"
                    :fit="'fill'" />
                  <span>{{ scope.row.odooName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="nDauKy" label="Đầu kỳ" align="center" width="120" />
            <el-table-column label="Thay đổi" align="center" width="120">
              <template #default="scope">
                <span v-if="scope.row.nThayDoi > 0" style="color: green">+{{ scope.row.nThayDoi }}</span>
                <span v-else style="color: red">{{ scope.row.nThayDoi }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="nCuoiKy" label="Cuối kỳ" align="center" width="120" />
          </el-table>
        </div>
      </div>

      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize" />
      </div>
    </div>

  </div>

</template>
<script>
import { Inventory } from "@/store/enums/StoreEnums";
import { baseUrl } from "@/utils/global";
import moment from "moment/moment";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
export default {
  data() {
    return {
      store: useStore(),
      baseUrl: baseUrl,
      isLoading: false,
      tableData: [],
      search: {
        createDate: [moment().add(-30, 'days'), moment()],
      },
      pageRequest: { pageNum: 1, pageSize: 30 },

    }
  },
  methods: {
    async getInventoryReport() {
      let fromDate = moment(this.search.createDate[0]).format("DD/MM/YYYY")
      let toDate = moment(this.search.createDate[1]).format("DD/MM/YYYY")

      this.pageRequest.columnFilters = {
        fromDate: { value: fromDate },
        toDate: { value: toDate },
      }
      const res = await this.store.dispatch(Inventory.inventoryReport, this.pageRequest)
      if (res.code === 200) {
        this.tableData = res.data
      }
    },

    handleSizeChange(val) {
      this.pageRequest.pageSize = val
      this.getInventoryReport()
    },

    handleCurrentChange(val) {
      this.pageRequest.pageNum = val
      this.getInventoryReport()
    },
  },
  mounted() {
    this.getInventoryReport()
  }
}
</script>
<style scoped>
.box-card {
  margin: 10px;
}

.tbl {
  height: calc(100vh - 225px);
}

.daterange-order .el-input__inner {
  border: 1px solid #b1b4b8;
}
</style>
